import {
  validateEvidenceLabConfig,
  type EvidenceLabConfig,
} from '../minigames/evidence-lab/EvidenceLabConfig.js';

export const SOUND_VIBRATION_INVESTIGATION: EvidenceLabConfig = {
  id: 'modeled-vibration-sound-1',
  skillId: 'science-sound-vibration-1',
  question: 'What relationship does the virtual sound model show?',
  subjects: [
    {
      id: 'still-string',
      label: 'STILL STRING',
      observation: 'The string stays still. The virtual sound meter shows no sound.',
      evidenceId: 'still-no-sound',
    },
    {
      id: 'small-drum-vibration',
      label: 'SMALL VIBRATION',
      observation: 'The drum surface moves a small amount. The model shows a quiet sound.',
      evidenceId: 'small-quiet',
    },
    {
      id: 'large-speaker-vibration',
      label: 'LARGE VIBRATION',
      observation: 'The speaker surface moves a larger amount. The model shows a louder sound.',
      evidenceId: 'large-louder',
    },
  ],
  conclusions: [
    {
      id: 'vibration-makes-sound',
      text: 'Vibrating objects make sound, and larger modeled vibrations match louder sounds.',
    },
    { id: 'still-loudest', text: 'Objects make the loudest sound when they are completely still.' },
    { id: 'size-unrelated', text: 'The modeled vibration amount and sound level are not related.' },
  ],
  correctConclusionId: 'vibration-makes-sound',
  requiredEvidenceIds: ['still-no-sound', 'small-quiet', 'large-louder'],
  hints: [
    'Record whether each surface is still or vibrating and what the virtual meter shows.',
    'Compare the small vibration with the larger vibration.',
    'The still object had no sound; the larger modeled motion matched the louder sound.',
  ],
  evidenceExplanation:
    'Across the safe virtual stations, sound appeared with vibration and increased as the modeled vibration grew larger.',
  successMessage: 'The listening deck lights up with gentle rings of sound!',
  restorationEvent: 'sound-vibration-deck-restored',
};

validateEvidenceLabConfig(SOUND_VIBRATION_INVESTIGATION);
